module.exports = __webpack_public_path__ + "img/10.3b9c3b91.png";